/**
 * SetupBanner — zeigt einen Hinweis auf das offene Betriebs-Onboarding
 * (Einrichtungs-Assistent) solange es nicht abgeschlossen ist. Admin only.
 */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Sparkles, ChevronRight, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function SetupBanner() {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (sessionStorage.getItem('setupBannerDismissed') === '1') return;
    axios.get(`${API}/einrichtung/state`).then(({ data }) => {
      if (data && !data.completed) {
        setShow(true);
        const steps = data.steps || [];
        const idx = Math.max(0, steps.indexOf(data.current_step || 'branche'));
        setProgress(steps.length ? Math.round((idx / (steps.length - 1)) * 100) : 0);
      }
    }).catch(() => {});
  }, []);

  if (!show) return null;

  return (
    <div data-testid="setup-banner"
      className="relative mb-6 overflow-hidden rounded-2xl border border-emerald-500/30 bg-gradient-to-r from-emerald-950/60 to-neutral-900 p-5">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 flex-none items-center justify-center rounded-xl bg-emerald-500/15 ring-1 ring-emerald-500/30">
            <Sparkles className="h-5 w-5 text-emerald-400" />
          </div>
          <div>
            <p className="font-semibold text-neutral-100">Studio-Einrichtung abschliessen</p>
            <p className="text-sm text-neutral-400">
              In wenigen Schritten startklar: Branding, Module und Testmonat {progress > 0 ? `· ${progress}% erledigt` : ''}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button onClick={() => navigate('/einrichtung')} data-testid="setup-banner-cta"
            className="bg-emerald-500 text-neutral-950 hover:bg-emerald-400">
            Jetzt einrichten <ChevronRight className="ml-1 h-4 w-4" />
          </Button>
          <button onClick={() => { setShow(false); sessionStorage.setItem('setupBannerDismissed', '1'); }}
            data-testid="setup-banner-dismiss" className="rounded-lg p-2 text-neutral-500 hover:text-neutral-300">
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
